import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useSegment } from '~/composables/_next/useSegment';
import { useTrpc } from '~/composables/_next/useTrpc';
import { cacheControl } from '~/helpers/cacheControl';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import MenuSubcategoryList from '~/components/Layout/Menu/components/MenuSubcategoryList.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import { HARD_CODED_SLUGS, PageTypes } from '~/types/PageTypes';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
      ],tracking: {
        category: TrackingPageCategory.ALL_ADVICES
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: 'all-advices',
  setup: function setup(__props) {
    var CUSTOM_PAGE_KEY = 'all-advices';
    ;
    provide('content', false);
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var _useNuxt2App = useNuxt2App(),
      error = _useNuxt2App.error,
      app = _useNuxt2App.app,
      i18n = _useNuxt2App.i18n;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var alpsList = useState('all-advices-list', function () {
      return null;
    });
    var pageCustom = useState('all-advices-content', function () {
      return null;
    });
    var headerTitle = computed(function () {
      var _pageCustom$value;
      return ((_pageCustom$value = pageCustom.value) === null || _pageCustom$value === void 0 ? void 0 : _pageCustom$value.title) || '';
    });
    var breadcrumbs = computed(function () {
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: i18n.t('utils.homeBreadcrumbs')
      }, {
        text: headerTitle.value
      }];
    });
    var bannerBackgroundImage = computed(function () {
      var _pageCustom$value2, _pageCustom$value2$ba;
      return ((_pageCustom$value2 = pageCustom.value) === null || _pageCustom$value2 === void 0 ? void 0 : (_pageCustom$value2$ba = _pageCustom$value2.bannerBackgroundImage) === null || _pageCustom$value2$ba === void 0 ? void 0 : _pageCustom$value2$ba.url) || null;
    });

    /**
     * Build a tree of ALPs from contentful result
     * @param items
     */
    var headerItems = computed(function () {
      var _alpsList$value;
      var nodes = {};
      var tree = [];
      var alps = (_alpsList$value = alpsList.value) === null || _alpsList$value === void 0 ? void 0 : _alpsList$value.filter(function (item) {
        return item.slug;
      });
      if (alps && alps.length > 0) {
        var _iterator = _createForOfIteratorHelper(alps),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            // build the nodes
            nodes[item.sys.id] = {
              id: item.sys.id,
              title: item.title,
              slug: item.slug,
              url: app.localePath({
                name: 'pages-slug',
                params: {
                  slug: item.slug
                }
              }),
              subItems: []
            };
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var _iterator2 = _createForOfIteratorHelper(alps),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            // fill the tree and subItems
            if (_item.parentAdviceListingPage && _item.parentAdviceListingPage.sys && nodes[_item.parentAdviceListingPage.sys.id]) {
              nodes[_item.parentAdviceListingPage.sys.id].subItems.push(nodes[_item.sys.id]);
            } else {
              tree.push(nodes[_item.sys.id]);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      // Sort to have those with subItems first.
      tree.sort(function (a, b) {
        var aHasChildren = a.subItems.length > 0;
        var bHasChildren = b.subItems.length > 0;
        if (aHasChildren !== bHasChildren) {
          return aHasChildren ? -1 : 1;
        }
        return a.title.localeCompare(b.title, 'fr', {
          sensitivity: 'base'
        });
      });
      return tree;
    });
    useLazyAsyncData('page-all-advices', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _pageCustom$value3;
      var seoFallback, seo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([
            // load contentful all advices page
            client.contentful.getCustomPage.query({
              locale: locale,
              key: CUSTOM_PAGE_KEY
            }).then(function (response) {
              var _response$data, _response$data$pageCu, _response$data$pageCu2;
              pageCustom.value = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$pageCu = _response$data.pageCustomCollection) === null || _response$data$pageCu === void 0 ? void 0 : (_response$data$pageCu2 = _response$data$pageCu.items) === null || _response$data$pageCu2 === void 0 ? void 0 : _response$data$pageCu2[0]) || null;
            }),
            // load advicelist pages to build the tree
            client.contentful.getAllAdviceListingPages.query({
              locale: locale
            }).then(function (response) {
              var _response$data2, _response$data2$pageA;
              alpsList.value = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$pageA = _response$data2.pageAdviceListingCollection) === null || _response$data2$pageA === void 0 ? void 0 : _response$data2$pageA.items) || [];
            })]);
          case 2:
            seoFallback = {
              title: headerTitle.value
            };
            seo = Object.assign({}, seoFallback, (_pageCustom$value3 = pageCustom.value) === null || _pageCustom$value3 === void 0 ? void 0 : _pageCustom$value3.seo, {
              slug: HARD_CODED_SLUGS.CUSTOM_ALL_ADVICES
            });
            setMeta(seo);
            if (!pageCustom.value) {
              error({
                statusCode: 404
              });
            }
            return _context.abrupt("return", true);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onMounted(function () {
      window.scrollTo(0, 0);
      setDynamicYieldContext('OTHER', ['All_Advice_Page']);

      // TODO: Remove after Nuxt 3 migration
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      var route = useRoute();
      analytics.page(TrackingPageCategory.ALL_ADVICES, PageTypes.CUSTOM_ALL_ADVICES, {
        path: route.fullPath
      });
    });
    setDynamicYieldContextSSR('OTHER', ['All_Advice_Page']);
    return {
      __sfc: true,
      CUSTOM_PAGE_KEY: CUSTOM_PAGE_KEY,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      error: error,
      app: app,
      i18n: i18n,
      locale: locale,
      setMeta: setMeta,
      client: client,
      alpsList: alpsList,
      pageCustom: pageCustom,
      headerTitle: headerTitle,
      breadcrumbs: breadcrumbs,
      bannerBackgroundImage: bannerBackgroundImage,
      headerItems: headerItems,
      NuxtLinkCustom: NuxtLinkCustom,
      MenuSubcategoryList: MenuSubcategoryList,
      AppCategoriesHeader: AppCategoriesHeader,
      AzBackToTopButton: AzBackToTopButton
    };
  }
});